module.exports = __webpack_public_path__ + "assets/img/tele2.816c9c59.svg";